import { useState } from 'react';
import { DEFAULT_DATE_FORMAT, formatDate, toNativeDatePickerFormat } from '../../utils';
export const useDatePicker = ({ dateFormat = DEFAULT_DATE_FORMAT, name, value, onBlur, onChange }) => {
    const [nativeValue, setNativeValue] = useState(value ? toNativeDatePickerFormat(value, dateFormat) : '');
    const handleChange = ({ target: { value, valueAsDate, validity } }) => {
        setNativeValue(value);
        _onChange(validity, valueAsDate);
    };
    const handleBlur = ({ target: { validity, valueAsDate } }) => {
        // when input date is invalid onChange is not called, so we need to call it explicitly here too
        !validity.valid && _onChange(validity, valueAsDate);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(name);
    };
    const _onChange = (validity, date) => {
        let formattedDate;
        if (isDateInvalid(validity)) {
            formattedDate = 'invalid';
        }
        else if (isDateEmpty(validity, date)) {
            formattedDate = undefined;
        }
        else {
            formattedDate = formatDate(date, dateFormat);
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(name, formattedDate);
    };
    return {
        value: nativeValue,
        onChange: handleChange,
        onBlur: handleBlur
    };
};
const isDateEmpty = (validity, date) => {
    return validity.valueMissing || date === null;
};
const isDateInvalid = (validity) => {
    return validity.badInput;
};
//# sourceMappingURL=useDatePicker.js.map